import PropTypes from "prop-types";
import React, { useEffect, useCallback, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const location = useLocation();
  const ref = useRef();
  const path = location.pathname;

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Contents")} </li>
            {/* <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ti-home"></i>

                <span>{props.t("Dashboard")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/users" className="waves-effect">
                {/* <i className="ti-home"></i> */}
                <i className="dripicons-user-group" />
                {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
                <span>{props.t("Users")}</span>
              </Link>
            </li>

            <li>
         
         <Link to="/category" className="waves-effect">
           {/* <i className="ti-home"></i> */}
           <i className="ti-view-grid"></i> 
           {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
           <span>{props.t("Categories")}</span>
         </Link>
         </li>

            <li>
         
              <Link to="/category" className="has-arrow waves-effect">
                {/* <i className="ti-home"></i> */}
                <i className=" ti-layout-list-thumb"></i> 
                {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
                <span>{props.t("Categories Data")}</span>
              </Link>
           
           

            <ul className="sub-menu" aria-expanded="false">

            <li>
              <Link to="/bodyparts" className="waves-effect ">
                {/* <i className="ti-home"></i> */}
                {/* <i className="ti-view-grid"></i>  */}
                {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
                <span>{props.t("BodyParts")}</span>
              </Link>
            </li>

            <li>
              <Link to="/exercise" className="waves-effect">
                {/* <i className="ti-home"></i> */}
                {/* <i className="ti-view-grid"></i>  */}
                {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
                <span>{props.t("Exercises")}</span>
              </Link>
            </li>


            <li>
              <Link to="/videos" className="waves-effect">
                {/* <i className="ti-home"></i> */}
                {/* <i className="ti-view-grid"></i>  */}
                {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
                <span>{props.t("Videos")}</span>
              </Link>
            </li>

            </ul>
             </li>

             <li>
         
         <Link to="/send-notifications" className="waves-effect">
           {/* <i className="ti-home"></i> */}
           <i className="ti-bell"></i> 
           {/* <span className="badge rounded-pill bg-primary float-end">1</span> */}
           <span>{props.t("Notifications")}</span>
         </Link>
         </li>



            {/* <li>
              <Link to="/appoitments" className="waves-effect">
              <i className="ti-list-ol"></i> 
                <span>{props.t("Appoitments")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/consultant" className="waves-effect">
              <i className="dripicons-medical" />

                <span>{props.t("Consultants")}</span>
              </Link>
            </li> */}


            {/* <li>
              <Link to="/doctor-form" className="waves-effect">
              <i className="ti-pencil-alt"></i>

                <span>{props.t("Register Consultent")}</span>
              </Link>
            </li> */}

           
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
